module.exports = __webpack_public_path__ + "media/icons/location-icon-55e1cb4b.svg";